export default class Vital {
    datas: any;
    constructor(datas: any) {
        this.datas = datas;
    }
    readBeneficiary(number: number): any {
        return this.datas.lstDonneesBeneficiaire?.find(
            (beneficiary: any) => beneficiary.numero === number,
        );
    }
    get socialSecurityNumber() {
        return this.datas.NIR + this.datas.cleNIR;
    }
}
